type NavigatorWithStandalone = Navigator & {
  standalone?: boolean;
};

/**
 * Проверяет, запущено ли приложение как PWA (standalone/fullscreen)
 * Работает на iOS, Android и в современных браузерах
 */
export function checkPwa(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    (navigator as NavigatorWithStandalone).standalone === true
  );
}